import { graphql } from "react-relay";
import { OnboardingAutopilotEvent } from "@components/onboarding-autopilot-event";

export const fragments = {
  org: graphql`
    fragment OnboardingChromeAutopilot_org on Org
    @argumentDefinitions(timeZone: { type: "String!" }) {
      ...OnboardingAutopilotEvent_org
      id
      primaryOrgEmail
      focusTimeSavedInHours
      domains
      userDefinedTeam {
        id
        calendarIds
      }
      autopilotEventsResponse(timeZone: $timeZone) {
        __typename
        ... on AutopilotEventsResponse {
          enabledOrganized {
            ...OnboardingAutopilotEvent_event
            calendarIds
            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  subjectType
                  subjectValue
                }
              }
              userTags {
                tag
                states {
                  active
                  subjectType
                  subjectValue
                }
              }
            }
            title
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            attendees {
              urnType
              urnValue
            }
          }
          enabledAttending {
            ...OnboardingAutopilotEvent_event
            calendarIds
            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  subjectType
                  subjectValue
                }
              }
              userTags {
                tag
                states {
                  active
                  subjectType
                  subjectValue
                }
              }
            }
            title
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
              displayName
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            attendees {
              urnType
              urnValue
            }
          }
          suggestedOrganized {
            ...OnboardingAutopilotEvent_event
            calendarIds
            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  subjectType
                  subjectValue
                }
              }
              userTags {
                tag
                states {
                  active
                  subjectType
                  subjectValue
                }
              }
            }
            title
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            attendees {
              urnType
              urnValue
            }
          }
          suggestedAttending {
            ...OnboardingAutopilotEvent_event
            calendarIds
            annotatedEvent {
              orgTags {
                tag
                state {
                  active
                  subjectType
                  subjectValue
                }
              }
              userTags {
                tag
                states {
                  active
                  subjectType
                  subjectValue
                }
              }
            }
            title
            createdMillis
            eventKey {
              externalEventId
            }
            organizer {
              urnValue
            }
            startTime {
              millis
            }
            endTime {
              millis
            }
            attendees {
              urnType
              urnValue
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
  orgPersons: graphql`
    fragment OnboardingChromeAutopilot_orgPersons on Org
    @argumentDefinitions(
      calendarIds: { type: "[String]!", defaultValue: [] }
      externalEventIds: { type: "[String!]!", defaultValue: [] }
    ) {
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            userId
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};

export const queryPersons = graphql`
  query OnboardingChromeAutopilotQuery(
    $orgRelayId: ID!
    $userCalendarIds: [String!]!
    $calendarIds: [String]!
    $externalEventIds: [String!]!
  ) {
    orgPersons: node(id: $orgRelayId) {
      ... on Org {
        canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $userCalendarIds) {
          __typename
          ... on CanScheduleResponseList {
            list {
              externalEventId
              canAutopilot
              attendeeNotInDomain
              organizerNotClockwiseUser
              isAllDayEvent
            }
          }
        }
        ...OnboardingChromeAutopilot_orgPersons
          @arguments(calendarIds: $calendarIds, externalEventIds: $externalEventIds)
      }
    }
  }
`;

export const query = graphql`
  query OnboardingChromeAutopilotRendererQuery($orgRelayId: ID!, $timeZone: String!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        autopilotEventsResponse(timeZone: $timeZone) {
          __typename
          ... on AutopilotEventsResponse {
            enabledOrganized {
              ...OnboardingAutopilotEvent_event
              calendarIds
              title
              createdMillis
              eventKey {
                externalEventId
              }
              organizer {
                urnValue
              }
              attendees {
                urnValue
              }
              startTime {
                millis
              }
              endTime {
                millis
              }
            }
            enabledAttending {
              ...OnboardingAutopilotEvent_event
              calendarIds
              title
              createdMillis
              eventKey {
                externalEventId
              }
              organizer {
                urnValue
                displayName
              }
              attendees {
                urnValue
              }
              startTime {
                millis
              }
              endTime {
                millis
              }
            }
            suggestedOrganized {
              ...OnboardingAutopilotEvent_event
              calendarIds
              title
              createdMillis
              eventKey {
                externalEventId
              }
              organizer {
                urnValue
              }
              attendees {
                urnValue
              }
              startTime {
                millis
              }
              endTime {
                millis
              }
            }
            suggestedAttending {
              ...OnboardingAutopilotEvent_event
              calendarIds
              title
              createdMillis
              eventKey {
                externalEventId
              }
              organizer {
                urnValue
              }
              attendees {
                urnValue
              }
              startTime {
                millis
              }
              endTime {
                millis
              }
            }
          }
          ... on GraphEntityError {
            message
          }
        }
        ...OnboardingChromeAutopilot_org @arguments(timeZone: $timeZone)
      }
    }
  }
`;
